import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/get-pocket': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M407.6 64H40.6C18.5 64 0 82.5 0 104.6V239.8C0 364.5 99.7 464 224.2 464 348.2 464 448 364.5 448 239.8V104.6C448 82.2 430.3 64 407.6 64zM245.6 332.5C233.2 344.3 214.2 343.6 203.2 332.5 89.5 223.6 88.3 227.4 88.3 209.3 88.3 192.4 102.1 178.6 119 178.6 136 178.6 135.1 182.4 224.2 267.9 314.8 181 312.8 178.6 329.7 178.6 346.6 178.6 360.4 192.4 360.4 209.3 360.4 227.1 357.5 225 245.6 332.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/get-pocket.js
// module id = SdIV
// module chunks = 144